<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <!-- <h1>Medical Reimbursements</h1> -->
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="projectFile.code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="projectFile.desc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Client"
              :class="classPadding"
              v-model="projectFile.client"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Area"
              v-model="projectFile.areaDesc"
              :class="classPadding"
              clearable
              readonly
              @click:clear="clearArea"
            >
              <template slot="append">
                <v-icon @click.stop="searchArea">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <pagination :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </pagination>

      <v-dialog v-model="editDialog" width="700" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Code"
                  :class="classPadding"
                  v-model="editProjectFile.code"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Description"
                  :class="classPadding"
                  v-model="editProjectFile.desc"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
                <v-text-field
                  label="Client"
                  :class="classPadding"
                  v-model="editProjectFile.client"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" :class="classPadding">
                <v-text-field
                  label="Area"
                  v-model="editProjectFile.areaDesc"
                  :class="classPadding"
                  clearable
                  readonly
                  @click:clear="clearArea"
                >
                  <template slot="append">
                    <v-icon @click.stop="searchArea">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="areaDialog" width="900">
      <v-card>
        <v-card-title>
          <span class="headline">Area</span>
        </v-card-title>
        <v-card-text>
          <area-pagination :show-title="false" :show-dense="false">
            <template slot="actions" slot-scope="{ item }">
              <v-btn @click.stop="selectArea(item)" text>Select</v-btn>
            </template>
          </area-pagination>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="areaDialog = false" text
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Pagination from "./Pagination";
import AreaPagination from "../../../../employment-info/organizational-level/area/Pagination";
import userAccessMixin from "../../../../../../mixins/userAccessMixin";
// import List from "./List";
const API_ENDPOINT = "/api/projectFile";
export default {
  metaInfo: {
    title: "Medical Reimbursements",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    // List
    Pagination,
    AreaPagination
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    projectFile: {},
    componentKey: 0,
    editProjectFile: {},
    editDialog: false,
    areaDialog: false
  }),
  methods: {
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.projectFile)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editProjectFile.code = rel.projectCode;
      this.editProjectFile.desc = rel.projectDesc;
      this.editProjectFile.areaCode = rel.areaCode;
      this.editProjectFile.areaDesc = rel.areaDesc;
      this.editProjectFile.client = rel.client;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.projectCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.projectFile = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.editProjectFile)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    searchArea() {
      this.areaDialog = true;
    },
    selectArea(item) {
      if (!this.editDialog) {
        this.projectFile.areaCode = item.areaCode;
        this.projectFile.areaDesc = item.areaDesc;
      } else {
        this.editProjectFile.areaCode = item.areaCode;
        this.editProjectFile.areaDesc = item.areaDesc;
      }
      this.areaDialog = false;
    },
    clearArea() {
      if (!this.editDialog) {
        this.projectFile.areaCode = null;
        this.projectFile.areaDesc = null;
      } else {
        this.editProjectFile.areaCode = null;
        this.editProjectFile.areaDesc = null;
      }
    }
  },
  created() {
    this.getUserAccessRights("ProjctFile");
  }
};
</script>
